import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const RolePlayIntelligenceConsultants = () => {
  const scenarios = [
    'Sales and client conversations',
    'Objection handling',
    'Difficult customer interactions',
    'Leadership and internal communication'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gray-900/90 to-blue-900/30 border border-cyan-500/30">
          <div className="flex items-start gap-6 mb-8">
            <div className="w-20 h-20 rounded-2xl overflow-hidden shadow-lg flex-shrink-0 border border-cyan-500/30">
              <img 
                src="https://customer-assets.emergentagent.com/job_f6991d0e-ab71-4b45-956d-bb71024e7667/artifacts/ijiaa7g5_Cadence.png" 
                alt="Traain Cadence"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
                Traain Cadence™
              </h2>
              <p className="text-xl text-cyan-400 font-semibold">
                Practice Without Being on Every Call
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-8 leading-relaxed">
            Traain Cadence delivers realistic, AI-powered role-play so clients can practice daily.
          </p>

          <div className="mb-8">
            <div className="grid md:grid-cols-2 gap-4">
              {scenarios.map((scenario, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-300">{scenario}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-8 p-6 rounded-xl bg-gradient-to-r from-green-900/20 to-cyan-900/20 border border-green-500/30">
            <p className="text-lg text-white">
              <span className="text-green-400 font-semibold">Real-time feedback. Clear scoring. Faster improvement.</span>
              <br />
              Your clients grow. You scale.
            </p>
          </div>

          <a href="/products/cadence">
            <Button
              variant="outline"
              className="border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 hover:border-cyan-400"
            >
              Learn More → Traain Cadence
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default RolePlayIntelligenceConsultants;
